import React from 'react';
import { Button } from '../../../../../components/Button';
import classes from './merge-pick-banner.module.scss';

type Props = {
  selectedTableIds: number[];
  tableLabelsById: Record<number, string>;
  onCancel?: () => void;
  onConfirm?: () => void;
};

// Summary: Navy merge pick-mode card: title, selected-count, table chips and cancel/confirm pills.
const MergePickBannerComponent: React.FC<Props> = ({ selectedTableIds, tableLabelsById, onCancel, onConfirm }) => {
  const count = selectedTableIds.length;
  return (
    <div className={classes.card}>
      <div className={classes.head}>
        <span className={classes.icon} aria-hidden="true">
          <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </span>
        <div className={classes.text}>
          <span className={classes.title}>מיזוג שולחנות</span>
          <span className={classes.subtitle}>{count === 1 ? 'נבחר שולחן אחד' : `נבחרו ${count} שולחנות`}</span>
        </div>
      </div>
      <div className={classes.chips}>
        {selectedTableIds.map((tableId) => (
          <span key={tableId} className={classes.chip} data-testid={`pos-areas-merge-chip-${tableId}`}>
            {tableLabelsById[tableId] ?? tableId}
          </span>
        ))}
      </div>
      <div className={classes.actions}>
        <Button variant="cancel" className={classes.cancel} dataTestId="pos-areas-merge-cancel" onClick={onCancel}>
          ביטול
        </Button>
        <Button
          variant="confirm"
          className={classes.confirm}
          dataTestId="pos-areas-merge-confirm"
          disabled={count < 2}
          onClick={onConfirm}
        >
          {count < 2 ? 'מזג שולחנות' : `מזג ${count} שולחנות`}
        </Button>
      </div>
    </div>
  );
};

export const MergePickBanner = React.memo(MergePickBannerComponent);
